// ====================================
// File: constants.js
// ====================================
import React from "react";
import Icons from "./Icons";

// Add PLACEHOLDER_TEXT export
export const PLACEHOLDER_TEXT = {
  experience: {
    jobTitle: "Senior Software Engineer",
    companyInfo: "Tech Company | San Francisco, CA",
    details:
      "• Led development of a key feature, resulting in a 20% increase in user engagement.\n• Mentored two junior developers, improving team productivity and code quality.",
  },
  // MODIFICATION: Added placeholder text for volunteer roles
  volunteer: {
    role: "Community Volunteer",
    organization: "Local Charity | Anytown, USA",
    details:
      "• Organized a fundraising event that raised over $5,000 for community programs.\n• Dedicated over 100 hours to sorting and distributing food donations.",
  },
  // MODIFICATION: Added placeholder text for projects
  projects: {
    title: "Personal Portfolio Website",
    technologies: "React, Next.js, Vercel",
    description:
      "• Designed and developed a fully responsive personal portfolio to showcase my work.\n• Implemented a blog section with statically generated pages for optimal performance.",
  },
  education: {
    degree: "Bachelor of Science in Computer Science",
    institution: "University of Technology",
    period: "2016 - 2020",
    details:
      "• GPA: 3.8/4.0\n• Relevant Coursework: Data Structures, Algorithms, Web Development",
  },
  skills: {
    technical: ["JavaScript", "React", "Node.js", "Python", "AWS"],
    soft: ["Leadership", "Communication", "Problem Solving"],
  },
};

export const PREMIUM_TEMPLATE_OPTIONS = [
  {
    id: "minimalist",
    name: "Minimalist Modern",
    description: "Clean single-column design with modern typography",
    icon: <Icons.FileText className="w-5 h-5" />,
    preview: "minimalist",
  },
  {
    id: "creative",
    name: "Creative Bold",
    description: "Stand-out design with colored sidebar",
    icon: <Icons.Lightbulb className="w-5 h-5" />,
    preview: "creative",
  },
  {
    id: "executive",
    name: "Executive Two-Column",
    description: "Professional layout with sidebar for skills and education",
    icon: <Icons.Menu className="w-5 h-5" />,
    preview: "executive",
  },
];

export const NAVIGATION_SECTIONS = [
  {
    id: "header",
    label: "Contact Info",
    icon: <Icons.User className="w-5 h-5" />,
  },
  {
    id: "main",
    label: "Experience",
    icon: <Icons.Briefcase className="w-5 h-5" />,
  },
  {
    id: "sidebar",
    label: "Skills & Education",
    icon: <Icons.GraduationCap className="w-5 h-5" />,
  },
];

export const SECTION_TEMPLATES = {
  main: {
    experience: {
      type: "experience",
      title: "Professional Experience",
      icon: <Icons.Briefcase className="w-4 h-4" />,
      description: "Work experience and employment history",
      items: [],
    },
    projects: {
      type: "projects",
      title: "Projects",
      icon: <Icons.Code className="w-4 h-4" />,
      description: "Personal or professional projects",
      items: [],
    },
    volunteer: {
      type: "volunteer",
      title: "Volunteer Experience",
      icon: <Icons.Heart className="w-4 h-4" />,
      description: "Community service and volunteer work",
      items: [],
    },
    achievements: {
      type: "achievements",
      title: "Achievements",
      icon: <Icons.Award className="w-4 h-4" />,
      description: "Notable accomplishments and recognition",
      items: [],
    },
    profile: {
      type: "profile",
      title: "Professional Profile",
      icon: <Icons.User className="w-4 h-4" />,
      description: "Brief summary about yourself",
      content: "",
    },
  },
  sidebar: {
    education: {
      type: "education",
      title: "Education",
      icon: <Icons.GraduationCap className="w-4 h-4" />,
      description: "Academic background and qualifications",
      items: [],
    },
    competencies: {
      type: "competencies",
      title: "Core Competencies",
      icon: <Icons.Star className="w-4 h-4" />,
      description: "Key skills and abilities",
      items: [],
    },
    technical: {
      type: "technical",
      title: "Technical Skills",
      icon: <Icons.Code className="w-4 h-4" />,
      description: "Programming languages and tools",
      items: [],
    },
    languages: {
      type: "languages",
      title: "Languages",
      icon: <Icons.Globe className="w-4 h-4" />,
      description: "Language proficiencies",
      items: [],
    },
    certifications: {
      type: "certifications",
      title: "Certifications",
      icon: <Icons.Award className="w-4 h-4" />,
      description: "Professional certifications",
      items: [],
    },
    interests: {
      type: "interests",
      title: "Interests",
      icon: <Icons.Heart className="w-4 h-4" />,
      description: "Personal interests and hobbies",
      items: [],
    },
    awards: {
      type: "awards",
      title: "Awards & Honors",
      icon: <Icons.Trophy className="w-4 h-4" />,
      description: "Recognition and achievements",
      items: [],
    },
    publications: {
      type: "publications",
      title: "Publications",
      icon: <Icons.BookOpen className="w-4 h-4" />,
      description: "Published works and articles",
      items: [],
    },
    social: {
      type: "social",
      title: "Social Impact",
      icon: <Icons.Users className="w-4 h-4" />,
      description: "Community involvement",
      items: [],
    },
  },
};
